import { Injectable } from '@angular/core';
import { Observable,  } from 'rxjs';
import { MessageService } from '../message.service';
import { HttpClient }from '@angular/common/http';
import { MilestoneImplemented, PagedResponseMilestoneImplemented } from '../models/MilestoneImplemented';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})



export class MilestoneImplementedService {
  readonly APIURL = environment.APIURL;
  constructor(private messageService:MessageService, private http:HttpClient) { }



  getMilestonesImplemented():Observable<PagedResponseMilestoneImplemented>{
    const data =  this.http.get<PagedResponseMilestoneImplemented>(this.APIURL+'/MilestoneImplemented' + '?PageNumber=1&PageSize=100');
    this.messageService.add('MilestoneImplemented Service: fetched MilestonesImplemented');
    return data;
  }

  getMilestoneImplemented(id: number): Observable<MilestoneImplemented> {
        const MilestoneImplemented =this.http.get<MilestoneImplemented>(this.APIURL+'/MilestoneImplemented/' + id);
    this.messageService.add(`MilestoneImplemented Service: fetched MilestoneImplemented with id=${id}`);
    return MilestoneImplemented;
  }
}